import { getAccessToken, clearAuthStorage } from '../services/api';
/**
 * PlayWhot.js - Route page for Whot stake/room games
 *
 * URL: /play/whot/:matchId
 * Extracts matchId from URL, JWT from localStorage.
 * Reads matchSource from navigation state (defaults to 'stake').
 */
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import WhotGame from '../components/games/WhotGame';

export default function PlayWhot() {
  const { matchId } = useParams();
  const navigate = useNavigate();
  const locationState = useLocation().state || {};
  const [jwtToken, setJwtToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getAccessToken();
    if (!token) {
      navigate('/login');
      return;
    }
    setJwtToken(token);
    setLoading(false);
  }, [navigate]);

  const handleGameEnd = (result) => {
    // The Whot result modal owns the end-of-game UI. Do not auto-navigate
    // after a timeout: that unmounts WhotGame while the result is visible and
    // produces the black/blank screen reported after game completion.
    // WhotGame calls this only when the player explicitly taps Continue.
    console.log('Whot game ended:', result);
    navigate('/dashboard');
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', background: '#0a0a1a', color: '#888', fontSize: '18px',
      }}>
        Loading game...
      </div>
    );
  }

  if (!matchId) {
    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', background: '#0a0a1a', color: '#ff4444',
      }}>
        <p>Invalid game. No match ID provided.</p>
        <button
          onClick={() => navigate('/dashboard')}
          style={{
            marginTop: 16, padding: '12px 24px', background: '#00d4aa',
            color: '#000', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700,
          }}
        >Back to Dashboard</button>
      </div>
    );
  }

  return (
    <WhotGame
      matchId={matchId}
      matchSource={locationState.matchSource || 'stake'}
      jwtToken={jwtToken}
      onGameEnd={handleGameEnd}
    />
  );
}
